module.exports = __webpack_public_path__ + "static/media/wordmark_white.705e635d.svg";